import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../Context/User/";
import { ACESSOS } from "../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../Validations/UsuarioTela";
import SubNavProdutos from "../CobrancaTab/subnavs/Produtos";
//import SubNavProdutos from "../CobrancaTab/subnavs/Produtos";
import SubNavDropDown from "../SubNavDropDown/SubNavDropDown";
import { SubNavGestaoVendaAtendimentos } from "./subnavs/ResultadoContato/GestaoVenAtendimento";
import { SubNavGestaoVenCadastro } from "./subnavs/ResultadoContato/GestaoVenCadastro";

export default function VendasTab() {
    const { UserInfor } = useUserInfor();

    return (
        <div className="tab-pane py-5 p-lg-0 active" id="RepasseTab">
            <div
                id="kt_header_menu2"
                className="header-menu header-menu-mobile header-menu-layout-default header-menu-root-arrow"
            >
                <ul className="menu-nav">
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.VENDAS.TELAS.DASHBOARD.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item"
                                      >
                                          <NavLink
                                              to={
                                                  ACESSOS.VENDAS.TELAS.DASHBOARD
                                                      .DS_PATH
                                              }
                                              exact
                                              activeClassName="active"
                                              className="menu-link"
                                          >
                                              <span className="menu-text">
                                                  Dashboard
                                              </span>
                                          </NavLink>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.VENDAS.TELAS.GESTAO_CLIENTES.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item"
                                      >
                                          <NavLink
                                              to={
                                                  ACESSOS.VENDAS.TELAS
                                                      .GESTAO_CLIENTES.DS_PATH
                                              }
                                              exact
                                              activeClassName="active"
                                              className="menu-link"
                                          >
                                              <span className="menu-text">
                                                  Gestão de Clientes
                                              </span>
                                          </NavLink>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}

                    <SubNavDropDown
                        title={"Atendimentos"}
                        telas={[
                            ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.TODOS
                                .ID_TELA,
                        ]}
                    >
                        <SubNavGestaoVendaAtendimentos />
                    </SubNavDropDown>

                    <SubNavDropDown
                        title={"Produtos"}
                        telas={[
                            ACESSOS.VENDAS.PRODUTOS.TELAS.PAINEL_IMPLANTACAO
                                .ID_TELA,
                        ]}
                    >
                        <SubNavGestaoVenCadastro />
                        <SubNavProdutos />
                    </SubNavDropDown>

                    {mostrarNavDeTela(
                        ACESSOS.VENDAS.TELAS.ANALISE_CREDITO.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.VENDAS.TELAS.ANALISE_CREDITO.DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Analise De Crédito
                                </span>
                            </NavLink>
                        </li>
                    )}

                    {mostrarNavDeTela(
                        ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.CRIAR_EQUIPE_VENDA
                            .ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO
                                        .CRIAR_EQUIPE_VENDA.DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Equipe de Venda
                                </span>
                            </NavLink>
                        </li>
                    )}

                    {mostrarNavDeTela(
                        ACESSOS.VENDAS.TELAS.GESTAO_RESERVAS.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.VENDAS.TELAS.GESTAO_RESERVAS.DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Gestão de Reservas
                                </span>
                            </NavLink>
                        </li>
                    )}

                    {mostrarNavDeTela(
                        ACESSOS.VENDAS.TELAS.ESPELHO_VENDAS.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.VENDAS.TELAS.ESPELHO_VENDAS.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Espelho Vendas
                                </span>
                            </NavLink>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}
